const initShopifySubscriptions = () => {
	const checkedRadio = document.querySelectorAll(".plan_card .group_list_item input:checked")
	checkedRadio.forEach(radio => {
		const planCard = radio.closest(".subscription_group")
		if (planCard) {
			planCard.classList.add("active")
		}
	})
	const radios = document.querySelectorAll(".plan_card .group_list_item input")
	radios.forEach(radio => {
		radio.addEventListener("change", () => {
			const planCard = radio.closest(".subscription_group")
			if (planCard) {
				planCard.classList.remove("active")
			}
		})
	})
}
 
const initAgeGate = () => {
	const ageGate = document.querySelector("[data-age-gate]")
	if (!ageGate) return

	const acceptButton = ageGate.querySelector("[data-age-gate-accept]")
	const declineButton = ageGate.querySelector("[data-age-gate-decline]")
	const cookieName = "thiagotequila-age-gate-verified"
	const cookieMaxAge = 365 * 24 * 60 * 60 // 1 year

	/** @param {string} name */
	const getCookie = (name) => {
		const parts = `; ${document.cookie}`.split(`; ${name}=`)
		if (parts.length === 2) return parts.pop()?.split(";").shift() ?? null
		return null
	}

	/** @param {string} name @param {string} value */
	const setCookie = (name, value) => {
		const secure = window.location.protocol === "https:" ? "; Secure" : ""
		document.cookie = `${name}=${value}; Path=/; Max-Age=${cookieMaxAge}; SameSite=Lax${secure}`
	}

	const closeAgeGate = () => {
		ageGate.setAttribute("hidden", "")
		document.body.classList.remove("age-gate-open")
	}

	const hasVerifiedAge = getCookie(cookieName) === "true"

	if (hasVerifiedAge) {
		closeAgeGate()
		return
	}

	ageGate.removeAttribute("hidden")
	document.body.classList.add("age-gate-open")

	acceptButton?.addEventListener("click", () => {
		setCookie(cookieName, "true")
		closeAgeGate()
	})

	declineButton?.addEventListener("click", () => {
		if (!(declineButton instanceof HTMLElement)) return
		const redirectUrl = declineButton.dataset.redirectUrl
		if (redirectUrl) {
			window.location.href = redirectUrl
		}
	})
}

document.addEventListener("DOMContentLoaded", () => {
	initShopifySubscriptions()
	initAgeGate()
})
